import apiInstance from "./axios";
import { create_payment } from "utils/services/api/schemas";

const paymentApi = {
  createPayment: async (data) => {
    const response = await apiInstance.post(create_payment, data);
    return response;
  },
};

export default paymentApi;
